import { render, staticRenderFns } from "./CustomerShippingAddressDeleteDrawer.vue?vue&type=template&id=010c3e91"
import script from "./CustomerShippingAddressDeleteDrawer.vue?vue&type=script&lang=js"
export * from "./CustomerShippingAddressDeleteDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports